import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useNavigate } from 'react-router'
import { assignHighlight, getNovelties, showNovelty, toggleFormNovelty } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'

export const useTableTools = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { globalBrandId, globalCountriesId, globalLanguageId } = useSelector((state: IRootState) => state.global)
  const [openDeleteNews, setOpenDeleteNews] = useState(false)
  const [newsSelected, setNewsSelected] = useState<number | false>(false)

  const handleEditNews = (id: number) => {
    dispatch(showNovelty({ id, type: 'newsSelected' }))
    dispatch(toggleFormNovelty({ type: 'newsSelected', change: false }))
  }

  const handleViewNews = (params: any) => {
    navigate(`${params.row.slug}`)
  }

  const handleOpenDeleteDialog = (id: number) => {
    setOpenDeleteNews(true)
    setNewsSelected(id)
  }

  const handleClickHighlight = (id: number, isHighlight: boolean) => {
    dispatch(
      assignHighlight({
        id,
        isHighlight
      })
    )
  }

  const handleCreateNews = () => {
    dispatch(toggleFormNovelty({ type: 'newsSelected', change: true }))
  }

  const handleClickSetOptions = (options: any) => {
    dispatch(
      getNovelties({
        brand_id: globalBrandId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        requesttype: 2,
        type: 'news',
        filterBy: options
      })
    )
  }

  return {
    handleEditNews,
    handleViewNews,
    handleOpenDeleteDialog,
    handleClickHighlight,
    handleCreateNews,
    handleClickSetOptions,
    setOpenDeleteNews,
    setNewsSelected,
    openDeleteNews,
    newsSelected
  }
}
